(function () {
  'use strict';

  document.querySelectorAll('.product__quantity, .v2-pdp__quantity').forEach(function (wrapper) {
    var input = wrapper.querySelector('[data-quantity-input]');
    var decreaseBtn = wrapper.querySelector('[data-qty-decrease]');
    var increaseBtn = wrapper.querySelector('[data-qty-increase]');

    if (!input || !decreaseBtn || !increaseBtn) return;

    decreaseBtn.addEventListener('click', function () {
      var current = parseInt(input.value, 10) || 1;
      var next = Math.max(1, current - 1);
      input.value = next;
      input.dispatchEvent(new Event('change', { bubbles: true }));
    });

    increaseBtn.addEventListener('click', function () {
      var current = parseInt(input.value, 10) || 1;
      input.value = current + 1;
      input.dispatchEvent(new Event('change', { bubbles: true }));
    });
  });
})();
